<template lang="pug">
IconBtn(@click="download()", title="CSV", icon="mdi-download")
</template>

<script>
import CSV from "/libs/utils/CSV";

export default {
  props: {
    report: { type: Array, default: null },
    period: { type: String, default: "" }, // YYYY-MM-DD to YYYY-MM-DD
  },
  methods: {
    download() {
      if (!this.report) return;
      const csv = new CSV();
      csv.addRow([
        "Discount",
        "Item",
        "Quantity",
        "Modifier",
        "Modifier Quantity",
      ]);
      for (const group of this.report) {
        for (const dish of group.dishes) {
          let discount = group.pctOff + "%";
          if (dish.modifiers?.length) {
            for (const i in dish.modifiers) {
              const modifier = dish.modifiers[i];
              let item = "";
              let quantity = "";
              if (i == 0) {
                item = dish.name;
                quantity = dish.quantity;
              } else {
                discount = "";
              }
              csv.addRow([
                discount,
                item,
                quantity,
                modifier.name,
                modifier.quantity,
              ]);
            }
          } else {
            csv.addRow([discount, dish.name, dish.quantity]);
          }
        }
      }
      csv.save(`discounted-items-${this.period}`);
    },
  },
};
</script>
